import { useTranslation } from '@/hooks/useTranslation'
import { cn } from '@/lib/utils'

interface ImprovementSpotlightLegendProps {
	type: 'bottleneck' | 'exception' | 'question'
}

export function ImprovementSpotlightLegend({ type }: ImprovementSpotlightLegendProps) {
	const { t } = useTranslation()

	return (
		<div
			className="pointer-events-none mt-2 flex items-center gap-3 rounded-lg border border-[#E6E4E0] bg-white/95 px-2.5 py-1.5 text-[11px] text-[#4A4A46] shadow-sm"
			role="note"
		>
			<span className="inline-flex items-center gap-1.5">
				<span
					className={cn(
						'inline-block size-2.5 rounded-[2px] border-[2.5px] bg-[#FFF1F2]',
						type === 'bottleneck' && 'border-[#BE123C] bg-[#FFF1F2]',
						type === 'exception' && 'border-[#B45309] bg-[#FFFBEB]',
						type === 'question' && 'border-[#1D4ED8] bg-[#EFF6FF]'
					)}
					aria-hidden
				/>
				{t('components.bpmnEditor.improvements.legendSelected')}
			</span>
			<span className="inline-flex items-center gap-1.5">
				<span
					className={cn(
						'inline-block size-2.5 rounded-[2px] border-2 border-dashed bg-white',
						type === 'bottleneck' && 'border-[#BE123C]',
						type === 'exception' && 'border-[#B45309]',
						type === 'question' && 'border-[#1D4ED8]'
					)}
					aria-hidden
				/>
				{t('components.bpmnEditor.improvements.legendRelated')}
			</span>
			<span className="inline-flex items-center gap-1.5">
				<span
					className="inline-block size-2.5 rounded-[2px] border border-[#C4C4BE] bg-[#EFEDE9] opacity-30"
					aria-hidden
				/>
				{t('components.bpmnEditor.improvements.legendDimmed')}
			</span>
		</div>
	)
}
